import { Button, Divider, Flex, Text, Box } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { CustomSearchbar } from '../../common/CustomSearchbar';
import PassTemplatesListFilter from './PassTemplatesListFilter';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import PassTemplateListSorter from './PassTemplateListSorter';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';
import { useCreateTemplateAction } from './hooks/useCreateTemplateAction';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

const PassTemplatesHeader = ({
  inputSearch = '',
  setInputSearch,
}: {
  inputSearch?: string;
  setInputSearch: (input: string) => void;
}) => {
  const { shouldRender } = useOrganizationStatus();
  const isReadOnly = useIsReadOnly();
  const { prebuiltEnabled, openPicker } = useCreateTemplateAction();

  return (
    <>
      <PageHeadingWithTrialProgress title="Pass templates" />
      <Text textStyle="bodyFamilyRegular" fontSize="18px" mb={4}>
        Create and edit as many templates as you need. Drafts are free to
        explore and never visible to your customers. When you're ready, publish
        your template to start issuing passes.
      </Text>
      <Divider borderColor="primaryBackground" mt={2} mb={8} />
      {shouldRender && (
        <Box w="full" mb="30px">
          <Flex w={{ base: '100%', sm: '80%' }} alignItems="center" mb="16px">
            <CustomSearchbar
              inputSearch={inputSearch}
              setInputSearch={setInputSearch}
              placeholder="Search by name"
            />
          </Flex>
          <Flex
            w="full"
            flexDirection={{ base: 'column-reverse', sm: 'row' }}
            justify="space-between"
            alignItems="center"
            gap={3}
          >
            <Flex gap="8px" flexWrap="wrap" mt={{ base: 0, sm: '12px' }}>
              <PassTemplatesListFilter />
              <PassTemplateListSorter />
            </Flex>
            {isReadOnly ? (
              <LockedActionButton
                reason="create-templates"
                px={{ base: '17px', sm: '30px' }}
                size="sm"
                minW="180px"
              >
                Create new template
              </LockedActionButton>
            ) : (
              <Button
                px={{ base: '17px', sm: '30px' }}
                aria-label="Create pass template"
                size="sm"
                minW="180px"
                {...(prebuiltEnabled
                  ? { onClick: openPicker }
                  : { as: RouterLink, to: '/pass-templates/create' })}
              >
                Create new template
              </Button>
            )}
          </Flex>
        </Box>
      )}
    </>
  );
};
export default PassTemplatesHeader;
